export enum ThreeDSStatus {
  IDENTIFY = 'IdentifyShopper',
  CHALLENGE = 'ChallengeShopper',
  REDIRECT = 'RedirectShopper',
}
